// bootstrap
import { Tooltip } from "react-bootstrap";

// TOOLTIPS
// delete
export const renderTooltipDelete = (props) => (
  <Tooltip {...props}>Delete Sale Order</Tooltip>
);

// edit
export const renderTooltipEdit = (props) => (
  <Tooltip {...props}>Edit Sale Order</Tooltip>
);
